const URL_REGEXP = /https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const isValidUrl = (url: string) => URL_REGEXP.test(url);
export const removeTrailingSlash = (t: string) => t.replace(/\/$/, '');

export const asHttps = (url: string) => {
  const u = url.replace('http://', 'https://');
  return u.indexOf('https://') === 0 ? u : `https://${u}`;
};

export const onlyHostname = (url: string) => {
  if (!url) {
    return url;
  }
  const u = new URL(url);
  return u.hostname;
};

export const toDomain = (url: string) => {
  try {
    const parsed = new URL(url);
    return parsed.origin;
  } catch {
    return url;
  }
};
export const pathnameWithoutQueryParams = (pathname: string) => {
  return pathname.match(/(.*)\?/)?.[1] || pathname;
};

export const withoutProtocol = (url: string) => {
  return url.replace(/^https?:\/\//, '');
};

export const truncateUrl = (url: string, maxLen: number) => {
  if (typeof url !== 'string') {
    throw new TypeError('Expected url to be a string');
  }

  if (typeof maxLen !== 'number') {
    throw new TypeError('Expected length to be a number');
  }

  if (url.length <= maxLen) {
    return url;
  }

  // Remove http:// or https://
  url = url.replace(/^https?:\/\//, '');

  // Remove www.
  url = url.replace(/^www\./, '');

  // Replace /foo/bar/foo/ with /…/…/…/
  let urlLength = url.length;
  while (urlLength > maxLen) {
    url = url.replace(/(.*[^/])\/[^/…]+\/([^/])/, '$1/…/$2');
    if (url.length === urlLength) {
      break;
    } else {
      urlLength = url.length;
    }
  }
  // Replace /…/…/…/ with /…/
  url = url.replace(/\/…\/(?:…\/)+/, '/…/');

  // Replace all params except first
  let idx;
  while (url.length > maxLen) {
    idx = url.lastIndexOf('&');
    if (idx === -1) {
      break;
    }
    url = url.substring(0, idx) + '…';
  }

  // Replace first param
  if (url.length > maxLen) {
    idx = url.lastIndexOf('?');
    if (idx !== -1) {
      url = url.substring(0, idx) + '?…';
    }
  }

  // Replace endless hyphens
  while (url.length > maxLen) {
    idx = url.lastIndexOf('-');
    if (idx === -1) {
      break;
    }
    url = url.substring(0, idx) + '…';
  }

  return url;
};

export const createEmbeddableIframeForUrl = (
  url: string,
  opts: {
    width: string;
    height: string;
    minHeight?: string;
  }
) => {
  const styleValue = opts.minHeight ? `min-height: ${opts.minHeight};` : '';
  return `<iframe width="${opts.width}" height="${opts.height}" style="${styleValue}"  src="${url}"></iframe>`;
};
